import { Router } from '@angular/router';
// Third party packages
import { TranslateService } from '@ngx-translate/core';
import * as moment from 'moment';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
// Custom packages
import { AuthService } from 'src/app/modules/auth/auth.service';
import { HelperService } from 'src/app/shared/services/helper.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "../../modules/auth/auth.service";
import * as i3 from "../services/helper.service";
import * as i4 from "ngx-cookie-service";
import * as i5 from "@ngx-translate/core";
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, authService, helperService, cookieService, translateService) {
        this.router = router;
        this.authService = authService;
        this.helperService = helperService;
        this.cookieService = cookieService;
        this.translateService = translateService;
        this.lang = this.translateService.currentLang || this.translateService.defaultLang;
    }
    AuthGuard.prototype.canActivate = function (route, state) {
        var _this = this;
        this.loggedUser = this.authService.loggedUser$.value;
        this.sessionExpiresAt = +this.cookieService.get('s.expiresAt'); // this.authService.sessionExpiresAt$.value;
        this.lang = this.cookieService.get('lang') || this.translateService.currentLang;
        // Check if token is expired
        if (this.loggedUser && this.loggedUser._id && (moment.unix(moment.now()) > moment.unix(this.sessionExpiresAt))) {
            // Users seems to be logged, but his token is expired.
            // Log him out (remove data from cookie) and return false
            this.authService.logout(false);
            return false;
        }
        // Check if user is already logged in authService
        if (this.loggedUser && this.loggedUser._id) {
            // User is logged and his token is not expired. Let's return true.
            return true;
        }
        // Check if users is logged with cookie
        // (if we came here: (i) user is logged but requested
        // brand new page through page refresh, (ii) user is
        // not logged in)
        return new Observable(function (observer) {
            _this.authService.checkLogin()
                .subscribe(function (res) {
                if (res instanceof Error || !res.status) { // If back-end is down we recive an error!
                    _this.helperService.handleError(res);
                    // this.authService.logout();
                    _this.router.navigate([_this.lang, 'auth', 'login'], { queryParams: { returnUrl: state.url } });
                    return observer.next(false);
                }
                // User logged,
                observer.next(true);
            }, function (err) {
                // User is not logged in, redirect him
                _this.authService.logout();
                _this.router.navigate([_this.lang, 'auth', 'login'], { queryParams: { returnUrl: state.url } });
                observer.next(false);
            });
        });
    };
    AuthGuard.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AuthGuard_Factory() { return new AuthGuard(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.AuthService), i0.ɵɵinject(i3.HelperService), i0.ɵɵinject(i4.CookieService), i0.ɵɵinject(i5.TranslateService)); }, token: AuthGuard, providedIn: "root" });
    return AuthGuard;
}());
export { AuthGuard };
